import styles from "../../styles/pages/admin.module.css";
import ChannelList from "../../components/ChannelList";
import { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { observer } from "mobx-react-lite";
import { appStore } from "../../stores";
import adminService from "../../services/admin";
import { Chat } from "../../models/chat";
import Modal from "../../components/Modal";
import AdminNav from "../../components/AdminNav";
import { SystemSettings } from "../../models/settings";


function Moderation() {
  const tg = window.Telegram.WebApp;
  const [chats, setChats] = useState([] as Chat[]);
  const [settings, setSettings] = useState({} as SystemSettings);
  const [getChatsProcess, setGetChatsProcess] = useState(false);
  const [getSettingsProcess, setGetSettingsProcess] = useState(false);
  const [processButtons, setProcessButtons] = useState([] as string[]);
  const [modalAll, setModalAll] = useState(false);
  const navigate = useNavigate();

  const getChats = async () => {
    setGetChatsProcess(true);
    const response = await adminService.getModeration();
    setGetChatsProcess(false);

    if (response.status === 200) {
      setChats(response.data.chats);
    } else {
      appStore.addError("При получении чатов на модерацию произошла ошибка");
    };
  };

  const getSystemSettings = async () => {
    setGetSettingsProcess(true);
    const response = await adminService.getSystemSettings();
    setGetSettingsProcess(false);

    if (response.status === 200) {
      setSettings(response.data);
    } else {
      appStore.addError("При получении настроек системы произошла ошибка");
    };
  };

  const cancel = () => {
    tg.HapticFeedback.impactOccurred("heavy");
    navigate("/offers", { replace: true });
  };

  useEffect(() => {
    tg.BackButton.show();
    tg.BackButton.onClick(cancel);
    
    getChats();
    getSystemSettings();
    
    return () => {
      tg.BackButton.offClick(cancel);
      tg.BackButton.hide();
    };
  }, []);

  const handleOpenChannel = async (chat: Chat) => {
    tg.HapticFeedback.impactOccurred("light");
    tg.openTelegramLink(chat.invite_link);
  };

  const handleSubscribeButton = async (updateChats: Chat[], type: "approve" | "decline") => {
    setProcessButtons(prev => [...prev, ...updateChats.map(c => `${c.id}|${type}`)]);
    
    const chatIds = updateChats.map(c => c.id);
    const response = await adminService.updateChatState(chatIds, type === 'approve');

    if (response.status === 200) {
      const curChats = [...chats];

      curChats.forEach(chat => {
        if (chatIds.includes(chat.id)) {
          chat.is_approved = type === 'approve';
        };
      });  
      setChats(curChats);
    } else {
      appStore.addError("При отправке решения модерации произошла ошибка");
    };

    setProcessButtons(prev => prev.filter(b => !chatIds.includes(Number(b.split("|")[0]))));
  };

  const confirmAllApprove = () => {
    setModalAll(false);
    handleSubscribeButton(chats.filter(c => c.is_approved === null), "approve");
  };

  const allApprove = () => {
    tg.HapticFeedback.impactOccurred("light");
    setModalAll(true);
  };

  const closeModal = () => {
    tg.HapticFeedback.impactOccurred("light");
    setModalAll(false);
  };

  const moderationSwitch = async (mode: "auto" | "manual") => {
    tg.HapticFeedback.impactOccurred("light");
    
    setGetSettingsProcess(true);
    const response = await adminService.updateSystemSettings(mode);
    setGetSettingsProcess(false);

    if (response.status === 200) {
      const curSettings = {...settings};
      curSettings.moderation = mode;
      setSettings(curSettings);
    } else {
      appStore.addError("При получении настроек системы произошла ошибка");
    };
  };

  const moderationMode = getSettingsProcess ? "Загрузка..." : (settings.moderation === "auto" ? "Авто" : "Ручная");
  const moderationSwitchHandler = getSettingsProcess ? () => {} : (settings.moderation === "auto" ? () => moderationSwitch("manual") : () => moderationSwitch("auto"));

  return (
    <div className={styles.body}>
        <span className={styles.header}>Модерация ({chats.length})</span>
        {modalAll && <Modal cancel={closeModal}>
            <h1>Одобрить все</h1>
            <span>После подтверждения будут одобрены все каналы, находящиеся на модерации</span>
            <button type="submit" onClick={confirmAllApprove}>Подтвердить</button>
          </Modal>}
        <ChannelList
          bottomButtons={{
            [moderationMode]: moderationSwitchHandler, 
            "Одобрить все": allApprove
          }}
          handleChannelButton={handleSubscribeButton}
          handleChannelClick={handleOpenChannel}
          mode="moderation"
          list={chats}
          nullMessage={getChatsProcess ? "Загрузка чатов на модерацию..." : "Нет чатов на модерации"}
          processButtons={processButtons}
          inline={false}
        />
        <AdminNav activePage={1}/>
    </div>
  );
}

export default observer(Moderation);